<div *ngIf="color === 'green'" class="loader"  [ngStyle]="{'width': size +'rem', 'height': size + 'rem'}"></div>
<div *ngIf="color === 'blue'" class="blue--loader"  [ngStyle]="{'width': size +'rem', 'height': size + 'rem'}"></div>
